angular
  .module('app.components')
  .controller('TechEdgeModalController', TechEdgeModal);

TechEdgeModal.$inject = [
  '$scope',
  '$filter',
  '$timeout',
  'close',
  'addSnapshot',
  'saveFromModal',
  'targetCampaign',
  'EventsService',
  'CampaignService',
  'CampaignManagerService',
];

function TechEdgeModal(
  $scope,
  $filter,
  $timeout,
  close,
  addSnapshot,
  saveFromModal,
  targetCampaign,
  EventsService,
  CampaignService,
  CampaignManagerService,
) {
  const vm = this;
  const {
    pid,
    name,
    type,
    start,
    c_start,
    end,
    c_end,
    sources,
    trackpoints,
  } = targetCampaign;

  vm.search = '';
  vm.saveFromModal = saveFromModal;
  vm.isStandardCampaign = type === 'standard';
  vm.isBarbStandardAvailable = targetCampaign.panel_country === 'GB';

  const sourceType = vm.isStandardCampaign ? 'tracking point' : 'source';



  /* ************************************************************* */
  /* ************************* Event types *********************** */
  /* ************************************************************* */
  vm.trackingSources = [];
  vm.trackingSourcesAll = [];

  vm.eventTypes = EventsService.getAllowedEventTypes();
  vm.availabelEventTypes = () => {
    const types = Object.keys(
      vm.trackingSources.reduce((memo, item) => ({
        ...memo,
        ...item.eventTypes,
      }), {})
    );

    return types.map(type => {
      return vm.eventTypes.find(item => item.type === type);
    });
  };
  vm.onSelectEventType = event => {
    vm.selectedEventType = vm.availabelEventTypes().find(({ type }) => event.type === type);
  };

  const initEventTypes = () => {
    vm.selectedEventType = vm.availabelEventTypes()[0];
  };



  /* ************************************************************* */
  /* ********************* Tracking sources ********************** */
  /* ************************************************************* */
  const initTrackingSources = (trackpoints, sources) => {
    const campaignTrackingSources = vm.isStandardCampaign ? trackpoints : sources;

    if (campaignTrackingSources) {
      vm.trackingSources = campaignTrackingSources.map(item => ({ ...item }));
      vm.trackingSourcesAll = campaignTrackingSources.map(item => ({ ...item }));
      vm.trackingSourcesAvailable = true;
    }
  };

  const initTrackingSourcesMenu = () => {
    vm.trackingSourcesMenu = [{
      id: 'all',
      label: `All ${sourceType}s (${vm.trackingSources.length})`,
    }, {
      id: 'selected',
      label: 'Include selected only',
    }];
    vm.selectedTrackingSources = vm.trackingSourcesMenu[0];
  };

  if (vm.saveFromModal) {
    vm.isProcessBusy = true;

    CampaignService.get({ id: pid }, response => {
      vm.isProcessBusy = false;
      initTrackingSources(response.trackpoints, response.sources);
      initTrackingSourcesMenu();
      initEventTypes();
    });
  } else {
    initTrackingSources(trackpoints, sources);
    initTrackingSourcesMenu();
    initEventTypes();
  }

  const onEditTrackingSources = () => {
    const selectedTrackingSources = vm.trackingSources.filter(item => (
      vm.selectedTrackingSources.id === 'all' || item.isSelected));
    vm.trackingSourcesAvailable = selectedTrackingSources.length !== 0;
  };

  vm.onSelectAllTrackingSources = select => {
    angular.forEach(vm.trackingSources, trackingSource => trackingSource.isSelected = !!select);
    onEditTrackingSources();
  };

  vm.onCheckTrackingPoint = trackingSource => {
    trackingSource.isSelected = !trackingSource.isSelected;
    onEditTrackingSources();
  };

  vm.onSelectTrackingSources = item => {
    vm.selectedTrackingSources = item;
    if (item.id === 'all') {
      vm.onSelectAllTrackingSources(true);
    } else {
      onEditTrackingSources();
    }
  };

  vm.onShowSearch = () => vm.searchVisible = !vm.searchVisible;
  vm.onClearSearch = () => {
    vm.searchVisible = false;
    vm.search = '';
  };

  $scope.$watch(() => vm.search,
    search => {
      vm.trackingSources = vm.trackingSourcesAll.filter(item => (
        !search || item.name.toLowerCase().includes(search.toLowerCase())));
    }, true);



  /* ************************************************************* */
  /* ************************ BarbStandard *********************** */
  /* ************************************************************* */
  vm.onSetupBarbStandard = () => {
    vm.snapshot.barbStandard = !vm.snapshot.barbStandard;
  };



  /* ************************************************************* */
  /* *************************** Period ************************** */
  /* ************************************************************* */
  const dateISO = $filter('dateISO');
  const dateLong = $filter('dateLong');
  const setPeriod = () => {
    vm.periodStart = start || c_start;
    vm.periodEnd = end || c_end;

    if (!vm.periodStart || !vm.periodEnd) {
      const monday = new Date();
      monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7); // set to Monday of this week
      monday.setDate(monday.getDate() - 7); // set to previous Monday
      const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6); // create new date of sunday

      vm.periodStart = monday;
      vm.periodEnd = sunday;
    }
  }

  setPeriod();

  vm.periodType = [{
    key: 'campaign',
    label: `Use campaign period (${dateLong(vm.periodStart)} - ${dateLong(vm.periodEnd)})`,
  }, {
    key: 'selected',
    label: 'Select period',
  }];

  vm.selectedPeriod = vm.periodType[0];
  vm.onSelectPeriod = key => {
    vm.selectedPeriod = vm.periodType.find(item => item.key == key);
    vm.showDatePicker = key === 'selected';

    if (key === 'campaign') {
      setPeriod();
    }
  }

  const getTrackingSources = () => {
    const key = vm.isStandardCampaign ? 'reportItems' : 'sources';

    return {
      [key]: vm.trackingSources.filter(item => (
        vm.selectedTrackingSources.id === 'all' || item.isSelected)),
    };
  }

  vm.snapshot = {
    name,
    type,
    brand: null,
    audiences: null,
    advertiserName: null,
    barbStandard: false,
  };

  const getSnapshot = () => ({
    ...vm.snapshot,
    ...getTrackingSources(),
    eventType: vm.selectedEventType && vm.selectedEventType.type,
  });



  /* ************************************************************* */
  /* *************************** Save **************************** */
  /* ************************************************************* */
  vm.save = () => {
    CampaignManagerService.addSnapshot({
      ...getSnapshot(),
      startDate: dateISO(vm.periodStart),
      endDate: dateISO(vm.periodEnd),
    });

    vm.inProgress = true;
    CampaignManagerService.saveNewSnapshots(pid)
      .then(() => {
        vm.inProgress = false;
        Notification.onSentToTechEdge({
          pid,
          name,
        });

        if (vm.saveFromModal) {
          CampaignManagerService.hideTechedgeNotification();
        }
        vm.close();
      });
  };

  vm.continue = () => {
    const snapshot = {
      ...getSnapshot(),
      id: new Date().getTime(), // tmp ID for new snapshot
      createdOn: new Date(),
      startDate: dateISO(vm.periodStart),
      endDate: dateISO(vm.periodEnd),
      syncing: 'pending',
      removable: true,
      isNewSnapshot: true,
    };

    addSnapshot(snapshot);
    vm.close();
  };



  /* ************************************************************* */
  /* ************************* Date picker *********************** */
  /* ************************************************************* */
  $timeout(() => {
    initDatepicker();
  }, 250);

  function initDatepicker() {
    const picker = $('#datePickerTechedge');
    picker.daterangepicker({
      startDate: vm.periodStart,
      endDate: vm.periodEnd,
      weekRanges: true,
      showWeekNumbers: true,
      locale: {
        firstDay: 1,
      },
      dateLimit: {
        months: 3,
      },
      format: 'yyyy-MM-dd',
    });

    const daterangepicker = $('.daterangepicker');
    daterangepicker.addClass('daterangepicker-static');
    picker.append(daterangepicker);

    picker.find('.calendar').click(() => {
      const data = picker.data('daterangepicker');
      const start = new Date(data.startDate);
      const end = new Date(data.endDate);
      const week = (end - start) / (24 * 60 * 60 * 1000);

      if (week < 6) {
        const sunday = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6); // create new date of sunday
        end.setDate(sunday.getDate());
      }

      vm.periodStart = start.setDate(start.getDate() + 1);
      vm.periodEnd = end.setDate(end.getDate() + 1);
    });
  }

  vm.close = () => {
    $('#datePickerTechedge').empty();
    close(false, 0);
  }
};
